import styled from '@emotion/styled';
import { Table, TableCell, TableContainer } from '@material-ui/core';
import { isInIFrame } from 'utils/services/kenticoSdk.service';

export const AddManyContentsTableMainContainer = styled.div`
  height: calc(100% - ${isInIFrame ? '68px' : '78px'});
`;

export const AddManyContentsTableTableContainer = styled(TableContainer)`
  max-height: calc(100% - 36px);
  padding-right: 6px;
`;

export const AddManyContentsTableHeaderTableCell = styled(TableCell)`
  background-color: #fff !important;
`;

export const AddManyContentsTableWorkflowStep = styled.div<{ background: string }>`
  display: inline-block;
  padding: 4px 8px;
  color: white;
  background-color: ${(props): string => props.background};
  text-transform: capitalize;
  border-radius: 4px;
`;

export const AddManyContentsTableTable = styled(Table)`
  background-color: #fff;

  & th {
    border-color: #ccc;
  }
`;

export const AddManyContentsTableSpinner = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px 0;
  height: 80px;
`;
